import { render, staticRenderFns } from "./MessageAddUsersCustomer.vue?vue&type=template&id=5ad4a385"
import script from "./MessageAddUsersCustomer.vue?vue&type=script&lang=js"
export * from "./MessageAddUsersCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports